// 20.1.2.2 Number.isFinite(number)
var $export   = require('./$.export')
  , _isFinite = require('./$.global').isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it){
    return typeof it == 'number' && _isFinite(it);
  }
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/es6.number.is-finite.js
 ** module id = 504
 ** module chunks = 0
 **/